export default __webpack_public_path__ + "static/media/mx.2cbad2d5.png";